import { ContactTypeValue } from '../enums/contact-type.value.enum';

export class ContactTypeConstants {
    public static phoneTypes = [
        { value: ContactTypeValue.PHONE, name: 'Phone' },
        { value: ContactTypeValue.MOBILE, name: 'Mobile' }
    ];
}



// WEBPACK FOOTER //
// ./src/app/common/constants/contact-type.constants.ts